import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Image, Row, Table } from 'react-bootstrap'
import styled from 'styled-components'
import ImgCheckbox from '../../../../images/checkbox.svg'
import { BsCheckCircleFill, BsCircleFill } from 'react-icons/bs'
import {
  getChecklistResignDetailAPI,
  putChecklistResignPDAdminAPI
} from '../../../../services/checklist'
import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'
import Error_false from '../../../error/error-false'
import { useSearchParams } from 'react-router-dom'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

export default function ResignsCheckListAdmin() {
  let [searchParams, setSearchParams] = useSearchParams()

  const [comment, setComment] = useState('')
  const [selectId, setSelectId] = useState(0)
  const [data, setData] = useState()
  const [isSave, setIsSave] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [createDate, setCreateDate] = useState([])
  const {
    setValue,
    setError,
    getValues,
    formState: { errors }
  } = useForm({
    resolver: yupResolver()
  })

  const dataPD = [
    {
      id: 1,
      label: 'รับคืนครบถ้วน'
    },
    {
      id: 2,
      label: 'รับคืนไม่ครบหรือสภาพเสียหาย'
    },
    {
      id: 3,
      label: 'ไม่ใช้งานคอมพิวเตอร์'
    }
  ]
  const dataWarehouse = [
    {
      id: 1,
      label: 'ไม่มีรายการยืมคงค้าง',
      isCheck: true
    },
    {
      id: 2,
      label: 'มีรายการคงค้าง',
      isCheck: false
    }
  ]
  const dataIT = [
    {
      id: 1,
      label: 'ดำเนินการครบถ้วน',
      isCheck: true
    },
    {
      id: 2,
      label: 'ค้างบางรายการ',
      isCheck: false
    }
  ]

  const dataManager = [
    {
      id: 1,
      label: 'อนุมัติแล้ว',
      isCheck: true
    },
    {
      id: 2,
      label: 'ไม่อนุมัติ',
      isCheck: false
    }
  ]

  const dataFinance = [
    {
      id: 1,
      label: 'ไม่มีรายการคงค้าง',
      isCheck: true
    },
    {
      id: 2,
      label: 'มีรายการคงค้าง',
      isCheck: false
    }
  ]
  const dataAccount = [
    {
      id: 1,
      label: 'ไม่มีรายการคงค้าง',
      isCheck: true
    },
    {
      id: 2,
      label: 'มีรายการคงค้าง',
      isCheck: false
    }
  ]

  const clrNo = searchParams.get('id')

  useEffect(() => {
    setIsLoading(true)
    fnGetDetail()
  }, [clrNo])

  const fnGetDetail = async () => {
    const body = { clrNo }
    const resp = await getChecklistResignDetailAPI(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setCreateDate(resp.result?.insert_date)

      setData(resp.result)
    } else {
      Error_false(resp)
    }
  }

  const fnSave = async () => {
    setIsSave(true)
    setIsLoading(true)
    const formData = getValues()
    const param = { clrNo }
    const body = {
      isConfirm: selectId === 0 ? false : true
    }
    const resp = await putChecklistResignPDAdminAPI(param, body)
    setIsLoading(false)
    setIsSave(false)

    if (!resp) return

    if (resp.status) {
      SwalCustom({
        title: 'Success!',
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        fnGetDetail()
      })
    } else {
      Error_false(resp)
    }
  }

  return (
    <Row className="mb-3 mt-3 p-3 overflow-auto">
      {isLoading && <div className="preloader"></div>}
      <Col xl={12}>
        <div className="mt-1 mb-3">
          <span className="fw-bold me-2">เลขเอกสาร: </span>
          <span className="">{clrNo}</span>{' '}
          <span className="fw-light me-2 ">
            {createDate
              ? moment(createDate).format('DD/MM/YYYY HH:mm')
              : ''}{' '}
          </span>
        </div>

        <div className="fw-bold mb-2 mt-4 ">รายการทรัพย์สิน</div>
        <Table bordered size="sm" className="mb-5">
          <thead className="bg-hrms">
            <tr>
              <th className="fw-light ">#</th>
              <th className="fw-light">Asset Tag</th>
              <th className="fw-light">Name</th>

              <th className="fw-light">Category</th>
              <th className="fw-light">Serial</th>
            </tr>
          </thead>
          <tbody>
            {data && data.asset.length > 0 ? (
              data.asset.map((d, i) => (
                <tr className="fw-light small" key={`tr-${i}`}>
                  <td>{i + 1}</td>
                  <td>{d?.asset_tag ?? '-'}</td>
                  <td>{d?.name ?? '-'}</td>
                  <td>{d?.category ?? '-'}</td>
                  <td>{d?.serial ?? '-'}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="text-center">
                  - No data -
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        <div className="fw-bold mb-3 ">1. การอนุมัติของหัวหน้างาน</div>

        {dataManager.map((d, i) => (
          <div key={`${d}-${i}`} className="">
            <label className="mb-2 fw-light">
              {data &&
              ((data.is_approve === 1 && d.id === 1) ||
                (data.is_approve === 0 && d.id === 2)) ? (
                <BsCheckCircleFill
                  className="me-2"
                  size={20}
                  style={{ color: '#408bff' }}
                />
              ) : (
                <BsCircleFill
                  className="me-2"
                  size={20}
                  style={{ color: '#bbbbbb' }}
                />
              )}
              {d.label}
            </label>
            {i > 0 && data?.is_approve === 0 ? (
              <div
                style={{
                  marginLeft: '35px',
                  maxWidth: '400px'
                }}
              >
                <BoxName className="rounded-3">
                  {data && data?.approve_description}
                </BoxName>
              </div>
            ) : (
              <></>
            )}
          </div>
        ))}

        <div className=" mt-5 font-small-2 d-flex justify-content-center mb-4">
          <div style={{ width: 300 }}>
            <div className="d-flex justify-content-center">
              {data && data.approve_by_detail.url && (
                <Image width={250} fluid src={data?.approve_by_detail?.url} />
              )}
            </div>
            <div className="d-flex justify-content-center">
              ลงชื่อ
              <div
                style={{
                  borderBottom: '1px dashed rgb(135, 135, 135)',
                  width: 200
                }}
              ></div>{' '}
              ผู้อนุมัติ
            </div>
            <div className="d-flex justify-content-center mt-3">
              (
              {data &&
                `${data?.approve_by_detail.title_th ?? ''}${
                  data?.approve_by_detail.name_th ?? '-'
                } ${data?.approve_by_detail.surname_th ?? ''}`}
              )
            </div>
            <div className="d-flex justify-content-center fw-light mt-1">
              {data && data.approve_by_detail.position_th}
            </div>
            <div className="d-flex justify-content-center fw-light">
              {data &&
                data.approve_date &&
                moment(data.approve_date).format('DD/MM/YYYY')}
            </div>
          </div>
        </div>
      </Col>
      <Col xl={12}>
        <div className="mb-3">
          <span className="fw-bold ">2. คลังสินค้า</span>
          <span> (ตรวจสอบการยืม/ส่งคืนทรัพย์สินคลังสินค้า)</span>
        </div>
        {dataWarehouse.map((d, i) => (
          <div key={`${d}-${i}`}>
            <label className="mb-2 fw-light">
              {data &&
              ((data.is_confirm1 === 1 && d.id === 1) ||
                (data.is_confirm1 === 0 && d.id === 2)) ? (
                <BsCheckCircleFill
                  className="me-2"
                  size={20}
                  style={{ color: '#408bff' }}
                />
              ) : (
                <BsCircleFill
                  className="me-2"
                  size={20}
                  style={{ color: '#bbbbbb' }}
                />
              )}
              {d.label}
            </label>
            {i > 0 && (
              <div
                style={{
                  marginLeft: '35px',
                  maxWidth: '400px'
                }}
              >
                <BoxName className="rounded-3">
                  {data && data.description1}
                </BoxName>
              </div>
            )}
          </div>
        ))}
        <div className=" mt-5 font-small-2 d-flex justify-content-center">
          <div style={{ width: 300 }}>
            <div className="d-flex justify-content-center">
              {data && data.confirm_detail1.url1 && (
                <Image width={250} fluid src={data.confirm_detail1.url1} />
              )}
            </div>
            <div className="d-flex justify-content-center">
              ลงชื่อ
              <div
                style={{
                  borderBottom: '1px dashed rgb(135, 135, 135)',
                  width: 200
                }}
              ></div>{' '}
              ผู้ดำเนินการ
            </div>
            <div className="d-flex justify-content-center mt-3">
              (
              {data &&
                `${data.confirm_detail1.title_th}${data.confirm_detail1.name_th} ${data.confirm_detail1.surname_th}`}
              )
            </div>
            <div className="d-flex justify-content-center fw-light mt-1">
              {data && data.confirm_detail1.position_th}
            </div>
            <div className="d-flex justify-content-center fw-light">
              {data &&
                data.confirm_date1 &&
                moment(data.confirm_date1).format('DD/MM/YYYY')}
            </div>
          </div>
        </div>
      </Col>
      <div className="pt-5">
        <p style={{ borderTop: '1px dashed rgb(135, 135, 135)' }}></p>
      </div>
      <Col xl={12}>
        <div className="mb-3">
          <span className="fw-bold ">3. บัญชี</span>{' '}
          <span>
            (เงินทดลองจ่ายคงค้าง, เอกสารเคลียร์เงิน, หรือเอกสารอื่น ๆ
            ที่สำคัญทางด้านระบบบัญชีและการเงิน)
          </span>
        </div>

        {dataAccount.map((d, i) => (
          <div key={`${d}-${i}`}>
            <label className="mb-2 fw-light">
              {data &&
              ((data.is_confirm2 === 1 && d.id === 1) ||
                (data.is_confirm2 === 0 && d.id === 2)) ? (
                <BsCheckCircleFill
                  className="me-2"
                  size={20}
                  style={{ color: '#408bff' }}
                />
              ) : (
                <BsCircleFill
                  className="me-2"
                  size={20}
                  style={{ color: '#bbbbbb' }}
                />
              )}
              {d.label}
            </label>
            {i > 0 && (
              <div
                style={{
                  marginLeft: '35px',
                  maxWidth: '400px'
                }}
              >
                <BoxName className="rounded-3">
                  {data && data.description2}
                </BoxName>
              </div>
            )}
          </div>
        ))}
        <div className=" mt-5 font-small-2 d-flex justify-content-center">
          <div style={{ width: 300 }}>
            <div className="d-flex justify-content-center">
              {data && data.confirm_detail2.url2 && (
                <Image width={250} fluid src={data.confirm_detail2.url2} />
              )}
            </div>
            <div className="d-flex justify-content-center">
              ลงชื่อ
              <div
                style={{
                  borderBottom: '1px dashed rgb(135, 135, 135)',
                  width: 200
                }}
              ></div>{' '}
              ผู้ดำเนินการ
            </div>
            <div className="d-flex justify-content-center mt-3">
              (
              {data &&
                `${data.confirm_detail2.title_th}${data.confirm_detail2.name_th} ${data.confirm_detail2.surname_th}`}
              )
            </div>
            <div className="d-flex justify-content-center fw-light mt-1">
              {data && data.confirm_detail2.position_th}
            </div>
            <div className="d-flex justify-content-center fw-light">
              {data &&
                data.confirm_date2 &&
                moment(data.confirm_date2).format('DD/MM/YYYY')}
            </div>
          </div>
        </div>
      </Col>
      <div className="pt-5">
        <p style={{ borderTop: '1px dashed rgb(135, 135, 135)' }}></p>
      </div>
      <Col xl={12}>
        <div className="mb-3">
          <span className="fw-bold ">4. การเงิน</span>{' '}
          <span>
            (เงินทดลองจ่ายคงค้าง, เอกสารเคลียร์เงิน, หรือเอกสารอื่น ๆ
            ที่สำคัญทางด้านระบบบัญชีและการเงิน)
          </span>
        </div>

        {dataFinance.map((d, i) => (
          <div key={`${d}-${i}`}>
            <label className="mb-2 fw-light">
              {data &&
              ((data.is_confirm3 === 1 && d.id === 1) ||
                (data.is_confirm3 === 0 && d.id === 2)) ? (
                <BsCheckCircleFill
                  className="me-2"
                  size={20}
                  style={{ color: '#408bff' }}
                />
              ) : (
                <BsCircleFill
                  className="me-2"
                  size={20}
                  style={{ color: '#bbbbbb' }}
                />
              )}
              {d.label}
            </label>
            {i > 0 && (
              <div
                style={{
                  marginLeft: '35px',
                  maxWidth: '400px'
                }}
              >
                <BoxName className="rounded-3">
                  {' '}
                  {data && data.description3}
                </BoxName>
              </div>
            )}
          </div>
        ))}
        <div className=" mt-5 font-small-2 d-flex justify-content-center">
          <div style={{ width: 300 }}>
            <div className="d-flex justify-content-center">
              {data && data.confirm_detail3.url3 && (
                <Image width={250} fluid src={data.confirm_detail3.url3} />
              )}
            </div>
            <div className="d-flex justify-content-center">
              ลงชื่อ
              <div
                style={{
                  borderBottom: '1px dashed rgb(135, 135, 135)',
                  width: 200
                }}
              ></div>{' '}
              ผู้ดำเนินการ
            </div>
            <div className="d-flex justify-content-center mt-3">
              (
              {data &&
                `${data.confirm_detail3.title_th}${data.confirm_detail3.name_th} ${data.confirm_detail3.surname_th}`}
              )
            </div>
            <div className="d-flex justify-content-center fw-light mt-1">
              {data && data.confirm_detail3.position_th}
            </div>
            <div className="d-flex justify-content-center fw-light">
              {data &&
                data.confirm_date3 &&
                moment(data.confirm_date3).format('DD/MM/YYYY')}
            </div>
          </div>
        </div>
      </Col>
      <div className="pt-5">
        <p style={{ borderTop: '1px dashed rgb(135, 135, 135)' }}></p>
      </div>
      <Col xl={12}>
        <div className="mb-3">
          <span className="fw-bold ">5. การตรวจสอบด้านระบบ IT</span>{' '}
          <span>
            (ระงับสิทธิการเข้าถึงข้อมูล บัตรพนักงาน, E-mail, ระบบ Access Control
            และระบบอื่น ๆ ที่เกี่ยวข้อง)
          </span>
        </div>
        {dataIT.map((d, i) => (
          <div key={`${d}-${i}`}>
            <label className="mb-2 fw-light">
              {data &&
              ((data.is_confirm4 === 1 && d.id === 1) ||
                (data.is_confirm4 === 0 && d.id === 2)) ? (
                <BsCheckCircleFill
                  className="me-2"
                  size={20}
                  style={{ color: '#408bff' }}
                />
              ) : (
                <BsCircleFill
                  className="me-2"
                  size={20}
                  style={{ color: '#bbbbbb' }}
                />
              )}
              {d.label}
            </label>
            {i > 0 && (
              <div
                style={{
                  marginLeft: '35px',
                  maxWidth: '400px'
                }}
              >
                <BoxName className="rounded-3">
                  {data && data.description4}
                </BoxName>
              </div>
            )}
          </div>
        ))}

        <Row>
          <Col className="col-6 d-flex align-self-xl-end justify-content-center">
            <div className=" mt-5 font-small-2 d-flex justify-content-center">
              <div style={{ width: 300 }}>
                <div className="d-flex justify-content-center">
                  {data && data?.confirm_detail4?.url4 && (
                    <Image
                      width={250}
                      fluid
                      src={data?.confirm_detail4?.url4}
                    />
                  )}
                </div>
                <div className="d-flex justify-content-center">
                  ลงชื่อ
                  <div
                    style={{
                      borderBottom: '1px dashed rgb(135, 135, 135)',
                      width: 200
                    }}
                  ></div>{' '}
                  ผู้ดำเนินการ
                </div>
                <div className="d-flex justify-content-center mt-3">
                  (
                  {`${data?.confirm_detail4?.title_th ?? ''}${
                    data?.confirm_detail4?.name_th ?? ' -'
                  } ${data?.confirm_detail4?.surname_th ?? ''}`}
                  )
                </div>
                <div className="d-flex justify-content-center fw-light mt-1">
                  {data && data?.confirm_detail4?.position_th}
                </div>
                <div className="d-flex justify-content-center fw-light">
                  {data &&
                    data?.confirm_date4 &&
                    moment(data?.confirm_date4).format('DD/MM/YYYY')}
                </div>
              </div>
            </div>
          </Col>

          <Col className="col-6 d-flex align-self-xl-end justify-content-center">
            <div className=" mt-5 font-small-2 d-flex justify-content-center">
              <div style={{ width: 300 }}>
                <div className="d-flex justify-content-center">
                  {data && data.confirm_detail4_2.url4_2 && (
                    <Image
                      width={250}
                      fluid
                      src={data.confirm_detail4_2.url4_2}
                    />
                  )}
                </div>
                <div className="d-flex justify-content-center">
                  ลงชื่อ
                  <div
                    style={{
                      borderBottom: '1px dashed rgb(135, 135, 135)',
                      width: 200
                    }}
                  ></div>{' '}
                  ผู้ตรวจสอบ
                </div>
                <div className="d-flex justify-content-center mt-3">
                  (
                  {`${data?.confirm_detail4_2.title_th ?? ''}${
                    data?.confirm_detail4_2.name_th ?? ' - '
                  } ${data?.confirm_detail4_2.surname_th ?? ''}`}
                  )
                </div>
                <div className="d-flex justify-content-center fw-light mt-1">
                  {data && data.confirm_detail4_2.position_th}
                </div>
                <div className="d-flex justify-content-center fw-light">
                  {data && data.confirm_date4_2
                    ? moment(data.confirm_date4_2).format('DD/MM/YYYY')
                    : '-'}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
      <div className="pt-5">
        <p style={{ borderTop: '1px dashed rgb(135, 135, 135)' }}></p>
      </div>
      <Col xl={12}>
        <div className="mb-3">
          <span className="fw-bold ">
            6. ตรวจสอบและเก็บคืนทรัพย์สินบริษัทฯ
          </span>{' '}
        </div>
        <CheckboxRadioCustom className="fw-light">
          {dataPD.map((d, i) => (
            <div className="form-check mb-3 " key={`${d}-${i}`}>
              {data && data.confirm_by5 === null && (
                <input
                  checked={d.id === selectId}
                  name={`description1`}
                  type="radio"
                  id={`inline-checkbox-${i}`}
                  className="form-check-input"
                  onChange={() => setSelectId(d.id)}
                />
              )}
              {data && data.confirm_by5 && (
                <>
                  <label className="mb-2 fw-light">
                    {(data?.is_confirm5 === 1 && d.id === 1) ||
                    (data?.is_confirm5 === 0 && d.id === 2) ||
                    (data?.is_confirm5 === 2 && d.id === 3) ? (
                      <BsCheckCircleFill
                        className="me-2"
                        size={20}
                        style={{ color: '#408bff' }}
                      />
                    ) : (
                      data &&
                      data?.confirm_by5 && (
                        <BsCircleFill
                          className="me-2"
                          size={20}
                          style={{ color: '#bbbbbb' }}
                        />
                      )
                    )}
                    {d?.label ?? '-'}
                  </label>
                  {d?.id === 2 && (
                    <div
                      style={{
                        marginLeft: '35px',
                        maxWidth: '400px'
                      }}
                    >
                      <BoxName className="rounded-3">
                        {data && data?.description5}
                      </BoxName>
                    </div>
                  )}
                </>
              )}

              {data && data?.confirm_by5 === null && (
                <div className="form-check-label">
                  <label htmlFor={`checkbox-radio-${i}`}>
                    {d?.label ?? '-'}
                  </label>

                  {d?.id === 2 && (
                    <div
                      style={{
                        marginLeft: '35px',
                        maxWidth: '400px'
                      }}
                    >
                      {selectId === 2 ? (
                        <Form.Control
                          as="textarea"
                          rows={3}
                          onChange={(e) => setComment(e.target.value)}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </CheckboxRadioCustom>
      </Col>

      <div className=" mt-5 font-small-2 d-flex justify-content-center">
        <div style={{ width: 300 }}>
          <div className="d-flex justify-content-center">
            {data && data?.confirm_detail5.url5 && (
              <Image width={250} fluid src={data?.confirm_detail5.url5} />
            )}
          </div>
          <div className="d-flex justify-content-center">
            ลงชื่อ
            <div
              style={{
                borderBottom: '1px dashed rgb(135, 135, 135)',
                width: 200
              }}
            >
              {' '}
            </div>
            ผู้ตรวจสอบ
          </div>
          <div className="d-flex justify-content-center mt-3 small">
            (
            {data?.confirm_detail5 &&
              `${data?.confirm_detail5?.title_th}${data?.confirm_detail5?.name_th} ${data?.confirm_detail5?.surname_th}`}
            )
          </div>
          <div className="d-flex justify-content-center small fw-light mt-1">
            {data?.confirm_detail5 && data?.confirm_detail5?.position_th}
          </div>
          <div className="d-flex justify-content-center small fw-light">
            {data?.confirm_detail5 && data?.confirm_date5
              ? moment(data?.confirm_date5).format('DD/MM/YYYY')
              : '-'}
          </div>
        </div>
      </div>

      {(data && data?.confirm_date1 === null) ||
      data?.confirm_date2 === null ||
      data?.confirm_date3 === null ||
      data?.confirm_date4 === null ||
      data?.confirm_date4_2 === null ||
      data?.confirm_date5 === null ? (
        <></>
      ) : (
        <>
          {data && data.is_confirm6 !== null ? (
            <Col xl={12} className="text-center">
              <Row>
                <Col>
                  <div className=" mt-5 font-small-2 d-flex justify-content-center">
                    <div style={{ width: 300 }}>
                      <div className="d-flex justify-content-center">
                        {data && data?.confirm_detail6.url6 && (
                          <Image
                            width={250}
                            fluid
                            src={data?.confirm_detail6.url6}
                          />
                        )}
                      </div>
                      <div className="d-flex justify-content-center">
                        ลงชื่อ
                        <div
                          style={{
                            borderBottom: '1px dashed rgb(135, 135, 135)',
                            width: 200
                          }}
                        ></div>{' '}
                        ผู้ตรวจสอบ
                      </div>
                      <div className="d-flex justify-content-center mt-3">
                        (
                        {data &&
                          `${
                            data?.confirm_detail6.title_th
                              ? data?.confirm_detail6.title_th
                              : ''
                          } ${
                            data?.confirm_detail6.name_th
                              ? data?.confirm_detail6.name_th
                              : ' - '
                          } ${
                            data?.confirm_detail6.surname_th
                              ? data?.confirm_detail6.surname_th
                              : ''
                          }`}
                        )
                      </div>
                      <div className="d-flex justify-content-center fw-light mt-1">
                        {data && data?.confirm_detail6.position_th}
                      </div>
                      <div className="d-flex justify-content-center fw-light">
                        {data &&
                          data?.confirm_date6 &&
                          moment(data?.confirm_date6).format('DD/MM/YYYY')}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          ) : (
            <Col xl={12} className="mt-5 text-center">
              <Button
                className="px-4"
                disabled={isSave}
                onClick={() => {
                  if (data.is_confirm5 !== null) {
                    fnSave()
                  } else {
                    SwalCustom({
                      icon: 'warning',
                      title: 'โปรดเลือกข้อมูล!',
                      text: 'กรุณาลองใหม่อีกครั้ง',
                      confirmButtonColor: ''
                    })
                  }
                }}
              >
                Submit
              </Button>
            </Col>
          )}
        </>
      )}
    </Row>
  )
}
const ColFrom = (props) => {
  const { children, className = '', ...other } = props

  return (
    <Col xl={3} xs={6} md={4} className={` ${className}`} {...other}>
      {children}
    </Col>
  )
}
const CheckboxRadioCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 1rem;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: "var(--comp-badge-color-background-primary)" !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid "var(--comp-badge-color-background-primary)";
  }
  label {
    margin: 0em 0em 0em 1em;
  }
  .form-check .form-check-input {
    float: left;
    margin-left: 0em;
  }
`

const BoxName = styled.div`
  font-size: 14px;
  width: 100%;
  background-color: #e3e3e3;
  border: 1px solid #e6e6e6;
  height: 35px;
  padding: 0.375rem 0.75rem;
`
